<div style="height: 100%;" [class]="{'layout-wrapper': estSesion,'layout-wrapper-menu-active':barLateralActiva && estSesion,
                                        'layout-overlay-menu':orientacion && estSesion}">
  <app-plantilla *ngIf="estSesion" (sidebarActiveEmit)="cambioEstadoBarraLateral($event)"
                 (overlayEmit)="cambioOrientacionMenu($event)"></app-plantilla>
  <div [class]="{'layout-main': estSesion}">
    <div [class]="{'layout-main-content': estSesion}">
      <!-- <hr> -->
      <section class="content-header" *ngIf="estSesion">
        <sd-breadcrumb></sd-breadcrumb>
      </section>
      <p-messages id="msgNotificacion" [value]="msgs" ([closable])="true"></p-messages>
      <p-toast id="msgToast" key="toastMessage"></p-toast>
      <router-outlet></router-outlet>
      <app-pie-pagina *ngIf="estSesion"></app-pie-pagina>
    </div>
  </div>
</div>

<ngx-spinner
  bdColor="rgba(51, 51, 51, 0.8)"
  size="medium"
  color="#58e175"
  type="timer"
></ngx-spinner>

<p-dialog id="dlgSessionOff" header="Advertencia"
          [(visible)]="display" modal="true"
          [draggable]="false" [resizable]="false">
  <div [translate]="'LBL_MENSAJECIERRE'" [translateParams]="{value: idleState}"></div>
</p-dialog>

